<div #header mat-dialog-title>
    Check In / Check Out
</div>

<div style="padding-left: 10px;">{{todaysDate | date:'MM/dd/yy'}}
    <span style="color: red;padding-left: 30px;" *ngIf="checkInOutSubmissionRequest.Id > 0">You are editing an existing request that was submitted at {{checkInOutSubmissionRequest.ProcessedTime}}</span>
</div>

<mat-dialog-content>
    <div style="padding-top: 10px;">
        <tyl-radio-group #typeRef style="margin-left: 10px;" arrange="vertical" name="Type"
            [(selected)]="checkInOutSubmissionRequest.Type" [values]="['I', 'O']" [labels]="['Check In', 'Check Out']"
            [ids]="['checkIn', 'checkOut']">
        </tyl-radio-group>
    </div>

    <div style="display: flex;flex-direction: row;padding-top: 10px;">
        <tyl-time-field width="105px"
            label="Time"
            name="Time"
            [required]="true"
            id="inpTime"
            [(timeValue)]="checkInOutSubmissionRequest.Time"
            [showNowButton]="true"></tyl-time-field>
    </div>

    <div>
        <tyl-form-field label="Reason" style="width:100%">
      <textarea matInput name="txtReason" Id="txtReason"
          style="resize: none;width:100%;vertical-align:top;padding-top:0px;padding-bottom:0px;"
          [(ngModel)]="checkInOutSubmissionRequest.Reason" rows="4"></textarea>
        </tyl-form-field>
    </div>

    <div *ngIf="angularMatData.data.length > 0">
        <div>Attachment</div>
        <div>
            <mat-table [dataSource]="angularMatData" aria-label="Attachment Table" tabindex="-1">
                <ng-container matColumnDef="FileName">
                    <mat-header-cell *matHeaderCellDef translate>File Name
                    </mat-header-cell>
                    <mat-cell *matCellDef="let AR">
                        <a style="cursor: pointer" (click)="saveAttachment(AR)">
                            {{AR.FileName}}
                        </a>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Description">
                    <mat-header-cell *matHeaderCellDef translate>Description
                    </mat-header-cell>
                    <mat-cell *matCellDef="let AR">{{AR.AttachmentDescription}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="DocumentType">
                    <mat-header-cell *matHeaderCellDef translate>File Type</mat-header-cell>
                    <mat-cell *matCellDef="let AR">
                        {{AR.DocumentType}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="UploadedDate">
                    <mat-header-cell *matHeaderCellDef translate>Uploaded Date
                    </mat-header-cell>
                    <mat-cell *matCellDef="let AR">
                        {{AR.AttachmentAddedOn|date:'MM/dd/yy h:mm a'}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Actions">
                    <mat-header-cell *matHeaderCellDef translate>Actions
                    </mat-header-cell>
                    <mat-cell *matCellDef="let AR">
                        <a style="font-size:10pt;cursor:pointer;text-decoration:underline;"
                            (click)="deleteAttachmentClick(AR.Id)">Delete</a>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="columnsToDisplay" tabindex="-1">
                </mat-header-row>
                <mat-row *matRowDef="let row; let i = index; columns: columnsToDisplay" tabindex="0">
                </mat-row>
            </mat-table>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions #footer>
    <div class='flex-footer-left'>
        <tyl-button image="add.png" label="Add Attachment" (click)="addAttachmentClick()"></tyl-button>
    </div>

    <div class='flex-footer-right'>
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="Save.png" label="Save" (click)="saveClick()"></tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (click)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>
